module.exports = __webpack_public_path__ + "static/img/zhuangji.ff8ecf1d.png";